import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from "react";
import { RichText } from "~/features/ui/rich-text";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
const fragment = graphql(`
  fragment AccordionListItemBulletPoint on blocks_accordionListItemBulletPoint_BlockType {
    title: baseText
    text: baseRichText
  }
`);
export type AccordionListItemBulletPointViewProps = {
  text?: React.ReactNode;
  title?: string | null;
};
export function AccordionListItemBulletPointView({
  text,
  title
}: AccordionListItemBulletPointViewProps) {
  return <_StyledDiv>
      {title && <_StyledDiv2>
          <_StyledSpan />
          <_StyledP>{title}</_StyledP>
        </_StyledDiv2>}
      {text}
    </_StyledDiv>;
}
export function AccordionListItemBulletPoint(props: FragmentType<typeof fragment>) {
  const {
    title,
    text
  } = useFragment(fragment, props);
  return <AccordionListItemBulletPointView text={text ? <RichText text={text} /> : undefined} title={title} />;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-fcxbc5-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "rowGap": "0.8rem"
});
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-fcxbc5-1"
})({
  "display": "flex",
  "alignItems": "center",
  "columnGap": "0.8rem",
  "@media (min-width: 1024px)": {
    "columnGap": "2.4rem"
  }
});
var _StyledSpan = _styled3("span").withConfig({
  componentId: "sc-sf-fcxbc5-2"
})({
  "height": "0.8rem",
  "width": "0.8rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});
var _StyledP = /*#__PURE__*/_styled4("p").withConfig({
  displayName: "accordion-list-item-bullet-point___StyledP",
  componentId: "sc-4pokg3-0"
})({
  "fontWeight": "500"
});